export default __webpack_public_path__ + "static/media/lull.05ff328f.png";